export const planningWorkPackageLimit = 10;

export interface WorkPackagesListProps {
  setDrawerStatus: (value: boolean) => void;
}

// NOTE: PlanningWorkPackageSlider enum has been moved to @bechtel/client-common
// Import it from there: import { PlanningWorkPackageSlider } from '@bechtel/client-common';
